import React from 'react'
import IconButton from '@material-ui/core/IconButton'
import DialogContent from '@material-ui/core/DialogContent'

import { Dialog, Icon } from 'src/chrome'
import { PaymentSuccess } from 'src/payments/components'
import { FlexColumn } from 'src/styled'

const styles = {
  paymentModal: {
    maxWidth: 'initial !important',
    '@media (max-width: 1075px)': {
      width: '90% !important',
    },
    '@media (max-width: 850px)': {
      width: '100% !important',
    },
  },
}

type Props = {
  onClose: () => void
}

const ThanksModal: React.FC<Props> = props => {
  const { onClose } = props

  return (
    <Dialog open={true} onClose={onClose} scroll={'paper'} maxWidth="lg">
      <DialogContent css={styles.paymentModal}>
        <IconButton
          style={{
            position: 'absolute',
            right: 12,
            top: 6,
          }}
          aria-label="close"
          onClick={onClose}
        >
          <Icon icon={'CLOSE'} color={'#6f8394'} size={18} />
        </IconButton>

        <FlexColumn
          style={{
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <PaymentSuccess />
        </FlexColumn>
      </DialogContent>
    </Dialog>
  )
}

export default ThanksModal
